import React from 'react';
import { services } from '../constants';
import ButtonLink from './ButtonLink';

const ServiceCard = ({ service }) => (
  <div className="w-full max-w-xs">
    <div className="relative overflow-hidden rounded-2xl border border-slate-800 bg-slate-900/60 p-[1px] shadow-[0_0_40px_rgba(56,189,248,0.15)]">
      <div className="flex min-h-[220px] flex-col items-center justify-center gap-4 rounded-2xl bg-gradient-to-br from-slate-900 via-slate-950 to-slate-900 px-6 py-8">
        <img
          src={service.icon}
          alt={service.title}
          className="h-14 w-14 object-contain"
        />
        <h3 className="text-center text-lg font-semibold text-slate-50">
          {service.title}
        </h3>
      </div>
    </div>
  </div>
);

const About = () => {
  return (
    <section id="about" className="min-h-screen w-full bg-gradient-to-b from-slate-950 via-slate-900 to-black text-white scroll-mt-24">
      <div className="mx-auto flex max-w-6xl flex-col gap-12 px-4 pt-28 pb-16 md:flex-row md:items-start reveal-on-scroll">
        <div className="flex-1 space-y-6">
          <p className="text-xs font-medium uppercase tracking-[0.3em] text-sky-400/80">
            About
          </p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-extrabold">
            <span className="bg-gradient-to-r from-sky-300 via-teal-300 to-emerald-300 bg-clip-text text-transparent">
              Introduction
            </span>
          </h2>
          <p className="max-w-xl text-sm sm:text-base leading-relaxed text-slate-300">
            Hi, I'm Abhay Varshney, a B.Tech student in Electrical and Electronics Engineering at IIT Patna (batch of 2027).
            I enjoy working at the intersection of software and hardware, with a growing interest in machine learning and
            full‑stack development. I love turning ideas into clean, performant, and user-friendly experiences.
          </p>
          <p className="max-w-xl text-sm sm:text-base leading-relaxed text-slate-300">
            As a
            <span className="mx-1 font-semibold text-emerald-300">full‑stack developer</span>
            I build responsive web applications that connect complex systems to intuitive interfaces. My projects are focused on
            learning by doing and shipping things that feel polished end‑to‑end.
          </p>
          <ButtonLink
            url="https://drive.google.com/file/d/1m2ZTJHUnwyqlkCnIYZPEETj_rck9TSSo/view?usp=sharing"
            text="View Resume →"
            padding="mt-2 inline-block px-6 py-3 bg-sky-500/90 border-sky-400"
          />
        </div>

        <div className="flex-1">
          <p className="mb-4 text-sm font-medium uppercase tracking-[0.25em] text-slate-400">
            What I enjoy
          </p>
          <div className="flex flex-wrap gap-6">
            {services.map((service) => (
              <ServiceCard key={service.title} service={service} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;